import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {MyPower} from '@eksab/features/store/badges/types';
import {useInvalidateMyPowers} from '@eksab/features/profile/hooks';

type PowerRevertTypes =
  | {
      competition_entry_id: number;
    }
  | {
      news_item_id: number;
    };

type PowerRevertParams = PowerRevertTypes & {id: number};
export function useRevertPowerConsumptionMutation(
  options?: UseMutationOptions<MyPower, AxiosError, PowerRevertParams>,
) {
  const invalidateMyPowers = useInvalidateMyPowers();

  return useMutation<MyPower, AxiosError, PowerRevertParams>(
    ({id, ...rest}) => api.post(`v1/user-powers/${id}/revert`, rest),
    {
      ...options,
      onSuccess: (...params) => {
        options?.onSuccess?.(...params);
        invalidateMyPowers();
      },
    },
  );
}
